export class EventBusRouter {
	constructor(dispatch) {
		this._nextHandler = null;
		this._dispatch = dispatch;
		this.exec = this.exec.bind(this);
	}
	async exec(name, ev){
		const res = await this._dispatch(name, ev);
        if (res && this._nextHandler) 
            await this._nextHandler.exec(name, ev);
		return ev;
	}
	setNext(next) {
		return (this._nextHandler = next);
	}
}